module.exports = __webpack_public_path__ + "img/DigitalSolution.20b99f0e.jpg";